<div class="app-network-studio w-100">

    <div class="row">
        <div class="col-12">
            <h2 class="waiting-room">
                <a role="button" class="back-button" (click)="goBack()"><i class="fa fa-chevron-circle-left"
                        aria-hidden="true"></i></a>
                <span class="pl-1" *ngIf="roomInfo?.name && roomInfo?.name.length <= 50"> {{roomInfo?.name}}</span>
                <span class="pl-1" *ngIf="roomInfo?.name && roomInfo?.name.length > 50" matTooltipPosition="above"
                    matTooltip="{{roomInfo?.name}}">
                    {{roomInfo?.name | slice: 0:50}}
                    {{roomInfo?.name.length > 50 ? "..." : ""}}
                </span>
                <span *ngIf="subRoomName && subRoomName.length <= 50"> / {{subRoomName}}</span>
                <span *ngIf="subRoomName && subRoomName.length > 50" matTooltipPosition="above"
                    matTooltip="{{subRoomName}}">
                    / {{subRoomName | slice: 0:50}}
                    {{subRoomName.length > 50 ? "..." : ""}}
                </span>
                <!-- {{roomInfo?.name}} 
                /  {{subRoomName}} -->
            </h2>
        </div>
        <!-- <div class="col-4 text-right">
            <a role="button" (click)="disconnect()" class="leave-btn pointer" matTooltipPosition="above"
                matTooltip="Leave room">
                <i class="fa fa-sign-out" aria-hidden="true"></i>
            </a>
        </div> -->
    </div>
    <div class="mt-50ppartNameCls">
         <!-- <div fxFlex="100%" fxLayout="row wrap" fxLayoutAlign="start start"> -->
    <a (click)="expand()" class="top-icon pointer" role="button" [ngClass]="isExpand ? 'collapseIcon' : 'expandIcon'">
        <!-- <img [src]="(isExpand)? assets_url + 'stream-icons/collapse.svg': assets_url + 'stream-icons/expand.svg'" id="expandButton" /> -->
        <span id="expandButton"><app-svg [icon]="(isExpand)? 'collapse': 'expand'"></app-svg></span>
    </a>
    <div class="w-100 row" id="videoWrapper" [ngClass]="!isExpand ? 'video-room plr-50' : 'plr-10'">
    </div>
    <!-- </div> -->
    </div>

    
    <div class="row">
        <div class="col-12 col-md-10 mb-4"><div class="list w-100">
            <ng-container *ngIf="(subRoomData && subRoomData?.length > 0) && !isExpand">
                <div class="room-container">
                   <div class="main-box">
                        <ng-container class="pointer" *ngFor="let room of subRoomData">
                            <div class="box-style">
                            <div>
                                <div>
                                    <p class="fs-20 text-center text-capitialize"
                                        *ngIf="room?.room && room?.room.length <= 30">
                                        {{room?.room}} </p>
                                    <p class="text-center" *ngIf="room?.room && room?.room.length > 30"
                                        matTooltipPosition="above" matTooltip="{{room?.room}}">
                                        {{room?.room | slice: 0:30}}
                                        {{room?.room.length > 30 ? "..." : ""}}
                                    </p>
                                </div>
                        
                                <div class="circle-container-main">
                                    <!-- <span class="circle-container-add pointer"
                                            (click)="showParticipants(r.id)"> <i
                                                class="fa fa-plus fs-18 plus-icon text-info" aria-hidden="true"></i> </span> -->
                                              
                                    <div>
                                        <ul class='circle-container'>
                                            <li *ngFor="let p of room.participants" matTooltipPosition="above"
                                                matTooltip="{{p?.name}}">
                                                <div class="roundIcon text-center ml-1"
                                                    [ngStyle]="{'background-color': p?.userColor }">
                                                    <span class="text-uppercase notranslate">{{p?.shortName}}</span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </div></div>
        <div class="col-12 col-md-2 mb-4 mt-80">
            <div class="pointer">    <div id="RightCarousel" class="carousel slide" data-ride="carousel" data-pause="hover">
                <div class="carousel-inner">
                    <ng-container *ngIf="streamAds && eventHomeAdsRight && eventHomeAdsRight.length > 0">
                        <div *ngFor="let a of eventHomeAdsRight; let i=index" class="adv-img2 carousel-item"
                            id="{{a.duration}}" [innerHtml]=a.image [ngClass]="{'active' : i == 0}">
                        </div>
                        <div class="ad-position">
                            <span class="icon-bg "><a class="text-center" [href]="selectedAdData" target="_blank" class="mr-2 text-white text-decoration-none">Learn more <i class="fa fa-external-link fs-9 ml-1" ></i></a></span> 
                        </div>
                    </ng-container>
                </div>
            </div></div>
        </div>
        <div class="mobile-rep col-12 w-100">
            <div class="d-flex justify-content-center align-item-center  w-100 mt-4">
                <div class="v-controls-div d-inline-block">
                    <div class="v-controls d-inline-block">
                        <a class="c-icons d-inline-block" (click)="soundOff()">
                            <!-- <img [src]="assets_url + 'stream-icons/mic-hover.svg'"
'                                [matTooltip]="(!soundStatus)?'Unmute Audio':'Mute Audio'" matTooltipPosition="above"
                                id="audioButton" /> -->
                            <span [matTooltip]="(!soundStatus)?'Unmute Audio':'Mute Audio'" matTooltipPosition="above"
                                id="audioButton"> <app-svg [icon]="audio_Icon"></app-svg></span>
                        </a>
                        <a class="c-icons d-inline-block" (click)="vidOff()">
                            <!-- <img [src]="assets_url + 'stream-icons/video-hover.svg'"
                                [matTooltip]="(!vidStatus)?'Play Video':'Pause Video'" matTooltipPosition="above"
                                id="videoButton" /> -->
                            <span [matTooltip]="(!vidStatus)?'Play Video':'Pause Video'" matTooltipPosition="above"
                                id="videoButton"><app-svg [icon]="video_Icon"></app-svg></span>
                        </a>
                     <a><button (click)="leaveRoom()" class="btn leave-room d-inline-block"> Leave Room</button></a>   
                    </div>
                 
                </div>
            </div>
        </div>
    </div>
 
   
</div>